import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE } from '../actions';

const initialState = {
    loading: false,
    userData: null,
    error: null,
};

export const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                ...state,
                loading: false,
                error: null,
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                loading: true,
                userData: action.payload,
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};
